//--- React
import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Row, Tabs } from "antd";
//--- Project
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import GetIframe from "components/Common/Grafana/GetIframe";
import { UNITS } from "components/Common/Constants";
import panelList from "../panelList.json";
import FullGraphsModal from "./fullGraphsModal";
import DecelerationAnalytics from "./Deceleration";

const AccelerationAnalytics = ({ baseUrl, baseFilterObject }) => {
  const [selectedTab, setSelectedTab] = useState("0-20");
  const vehicleDetails = useSelector((state) => state.eol.vehicleDetails);
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [accelerationList, setAccelerationList] = useState([]);

  useEffect(() => {
    setAccelerationList(panelList?.acceleration);
  }, []);

  const baseFilterValues = useMemo(() => {
    return { ...baseFilterObject, accl_range: selectedTab };
  }, [baseFilterObject, selectedTab]);

  const onChangeTab = (value) => {
    setSelectedTab(value);
  };

  const items = [
    {
      key: "0-20",
      label: "0-20",
    },
    {
      key: "0-40",
      label: "0-40",
    },
    {
      key: "0-60",
      label: "0-60",
    },
    {
      key: "0-80",
      label: "0-80",
    },
  ];

  const subContent = (
    <Row gutter={[16, 16]} justify="end" className="mt105">
      <Col xs={12} sm={12} md={12} lg={4} xl={4} className="flex-center">
        Max:{" "}
        <span className="ml025 mr025 bold">{tripSummary?.maxAccelerationMps2}</span>
        {UNITS.METER_PER_SECONDS_SQUARED}
      </Col>
      <Col xs={12} sm={12} md={12} lg={4} xl={4} className="flex-center">
        Min:{" "}
        <span className="ml025 mr025 bold">{tripSummary?.minAccelerationMps2}</span>
        {UNITS.METER_PER_SECONDS_SQUARED}
      </Col>
    </Row>
  );

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} lg={12}>
        {subContent}
        <Row className="mt105 pd0">
          <Col span={24}>
            <Tabs
              activeKey={selectedTab}
              items={items}
              type="card"
              onChange={onChangeTab}
              className="celeration-tab-view"
              tabBarExtraContent={
                <FullGraphsModal
                  modalTitle="Acceleration"
                  vehicleDetails={vehicleDetails}
                  baseUrl={baseUrl}
                  baseFilterObject={baseFilterValues}
                  variableKeys={TEST_RIDE_SUMMARY.ACCL_VARIABLES}
                  chartList={["AccelerationDistance", "AccelerationDuration"]}
                />
              }
            />
            <Row className="pd0">
              {accelerationList?.map((panel, index) => (
                <Col key={index} span={24}>
                  {vehicleDetails?.imeiNumber && (
                    <Row gutter={[12, 12]} className="pdtb05">
                      <Col span={24} id={`${panel.title}-timeseries`}>
                        <GetIframe
                          title={panel.title}
                          url={baseUrl}
                          panelId={
                            TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name][
                              "timeSeries"
                            ]
                          }
                          variableObject={baseFilterValues}
                          variableKeys={TEST_RIDE_SUMMARY.ACCL_VARIABLES}
                          width="100%"
                          height="240"
                          divId={`${panel.title}-timeseries`}
                        />
                      </Col>
                    </Row>
                  )}
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Col>
      <Col xs={24} sm={24} lg={12}>
        <DecelerationAnalytics
          baseUrl={baseUrl}
          baseFilterObject={baseFilterObject}
        />
      </Col>
    </Row>
  );
};

export default AccelerationAnalytics;
